import React from 'react';
import Material from './components/material';
import './mine-collapse.less';

const MineCollapse = () => {
    return (
        <div className="app-slide-content app-slide-mine">
            <Material />
        </div>
    );
};

export default React.memo(MineCollapse);
